import cn from 'classnames';

import { IConDefaultType } from '../../types';
export enum ApprovalIconVariant {
  DEFAULT = 'default',
}
export interface IApprovalIconProps extends IConDefaultType {
  variant?: ApprovalIconVariant;
}

export default function ApprovalIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = ApprovalIconVariant.DEFAULT,
}: IApprovalIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === ApprovalIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M1.6665 16.6673V14.334C1.6665 13.8757 1.78456 13.4451 2.02067 13.0423C2.25678 12.6395 2.58317 12.334 2.99984 12.1257C3.70817 11.7645 4.50678 11.459 5.39567 11.209C6.28456 10.959 7.26373 10.834 8.33317 10.834C8.74984 10.834 9.15609 10.8548 9.55192 10.8965C9.94775 10.9382 10.3332 11.0007 10.7082 11.084L9.24984 12.5423C9.09706 12.5145 8.94775 12.5007 8.80192 12.5007H8.33317C7.34706 12.5007 6.46164 12.6187 5.67692 12.8548C4.8922 13.0909 4.24984 13.3479 3.74984 13.6257C3.62484 13.6951 3.52414 13.7923 3.44775 13.9173C3.37136 14.0423 3.33317 14.1812 3.33317 14.334V15.0007H8.5415L10.2082 16.6673H1.6665ZM12.9582 17.0007L10.0832 14.1257L11.2498 12.959L12.9582 14.6673L17.1665 10.459L18.3332 11.6257L12.9582 17.0007ZM8.33317 10.0007C7.4165 10.0007 6.63178 9.67426 5.979 9.02148C5.32623 8.36871 4.99984 7.58398 4.99984 6.66732C4.99984 5.75065 5.32623 4.96593 5.979 4.31315C6.63178 3.66037 7.4165 3.33398 8.33317 3.33398C9.24984 3.33398 10.0346 3.66037 10.6873 4.31315C11.3401 4.96593 11.6665 5.75065 11.6665 6.66732C11.6665 7.58398 11.3401 8.36871 10.6873 9.02148C10.0346 9.67426 9.24984 10.0007 8.33317 10.0007ZM8.33317 8.33398C8.7915 8.33398 9.18386 8.17079 9.51025 7.8444C9.83664 7.51801 9.99984 7.12565 9.99984 6.66732C9.99984 6.20898 9.83664 5.81662 9.51025 5.49023C9.18386 5.16385 8.7915 5.00065 8.33317 5.00065C7.87484 5.00065 7.48248 5.16385 7.15609 5.49023C6.8297 5.81662 6.6665 6.20898 6.6665 6.66732C6.6665 7.12565 6.8297 7.51801 7.15609 7.8444C7.48248 8.17079 7.87484 8.33398 8.33317 8.33398Z"
            fill="black"
          />
        </svg>
      )}
    </i>
  );
}
